module.exports = __webpack_public_path__ + "img/header-countryicon.29de255.png";